import get from 'lodash/get';
import { createConsts, createActions } from '../../utils/redux';

const supportedActions = ['ADD_ITEM', 'REMOVE_ITEM', 'CLEAR'];

export const consts = createConsts('board', 'replies', ...supportedActions);
export const actions = createActions(consts);

const initState = {};

const addItem = (state, action) => {
  const channelId = get(action.payload, 'channelId');

  return {
    ...state,
    [channelId]: action.payload,
  };
};

const removeItem = (state, action) => {
  const channelId = action.payload;
  const updatedState = { ...state };

  delete updatedState[channelId];

  return updatedState;
};

export default (state = initState, action) => {
  switch (action.type) {
    case consts.ADD_ITEM:
      return addItem(state, action);
    case consts.REMOVE_ITEM:
      return removeItem(state, action);
    case consts.CLEAR:
      return initState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/board/replies.js